import { DealPipelineComponent } from "@/features";

export const DealPipelinePage = () => {
  return <DealPipelineComponent />;
}